import { IHoliday } from '@luggagehero/shared/interfaces';

export class HolidayUtil {
  static isSameHoliday(a: IHoliday, b: IHoliday): boolean {
    if (!a || !b) {
      return false;
    }
    if (a.countryCode !== b.countryCode) {
      return false;
    }
    if (a.key !== b.key) {
      return false;
    }
    return true;
  }
}
